import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {

  public dateTimeNow: Date;
  public dateTimeNowFormatted: string;
  public timezone: string;
  public offset: number;
  
  constructor() { }

  updateDatetimeNow(timezone: string, format: string){
    this.dateTimeNow = new Date();
    this.timezone = timezone;
      
    let momentFormatted = moment().tz(timezone).format();
    this.offset = moment().tz(timezone).utcOffset() / 60;
    this.dateTimeNow = new Date(momentFormatted.substring(0, 19));
    
    this.dateTimeNowFormatted = this.getFormattedDateTime(this.dateTimeNow, format);
  }

  getFormattedDateTime(dateTime: Date, format: string): string{
    var year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(dateTime);
    var month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(dateTime);
    var day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(dateTime);
    var time = new Intl.DateTimeFormat('en', { hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(dateTime);
    var dateTimeFormatted = "";

    if(format == 'US')
      dateTimeFormatted = `${month}/${day}/${year} ${time}`;
    else
      dateTimeFormatted = `${day}/${month}/${year} ${time}`;

    return dateTimeFormatted;
  }

  getTimestampInTimezone(timestamp: Date, timezone: string): Date{
    let utcTime = moment.utc(timestamp, 'YYYYMMDD HH:mm:ss');
    if(moment.tz.zone(timezone)){
      let momentTime = utcTime.clone().tz(timezone).format();
      return new Date(momentTime.substring(0, 19));
    }else{
      return new Date(timestamp);
    }
    
  }
}
